import { cards } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-2">
          深度爆料
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          独家调查与深度追踪，还原事件背后的真实故事
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {cards.map((card, i) => (
            <article
              key={i}
              className={`group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
                    i === 0 ? 'h-52 md:h-64' : 'h-44 md:h-48'
                  }`}
                  loading={i > 3 ? 'lazy' : undefined}
                />
                {card.tag && (
                  <span className="absolute top-3 left-3 px-2 py-1 rounded text-[11px] font-medium bg-primary-500 text-background-50 whitespace-nowrap">
                    {card.tag}
                  </span>
                )}
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-medium text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 mb-2 line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}